export default class Table {
  public static MAX_ITEMS_PER_PAGE = 100;
  public static DEFAULT_TABLE_DEBOUNCE_TIME = 330;
  public static ITEMS_PER_PAGE_OPTIONS = [10, 25, 50, 100];
  public static DEFAULT_ITEMS_PER_PAGE = 25;
}
